import { EuiSpacer } from '@elastic/eui';
import ScheduleTable from 'components/Web_User_Interface/720p_Series/Alarm/Schedule/scheduleTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  ScheduleTable,
  BreadCrumbs,
  SEOHelmet,
  React
};